<template>
  <!-- NOTES:
    * where in the world is the close button?
  -->
  <div class="change-password">
    <p class="title">{{this.title}}</p>
    <div class="circle" :class="{active:step == 1}"></div>
    <div class="circle middle" :class="{active:step == 2}"></div>
    <div class="circle" :class="{active:step == 3}"></div>
    <p class="desc">{{this.desc}}</p>
    <div v-if="step == 1" class="step1">
      <input v-model="oldpwd" type="password" placeholder="Your current password" />
    </div>
    <div v-else-if="step == 2" class="step2">
      <input class="new-email" v-model="newpwd" type="password" placeholder="Your new password" />
      <input v-model="newCpwd" type="password" placeholder="Confirm your new password" />
    </div>
    <div v-else class="step3">
      <!-- <email-success/> -->
      <img src="@/assets/success.png" />
    </div>
    <div class="buttons">
      <p v-if="step < 3" @click="close" class="close">cancel</p>
      <p @click="firebtn" class="btn">{{this.btn}}</p>
    </div>
  </div>
</template>

<script>
import { CheckOldPwd, SetNewPwd } from "@/api/index.js";
export default {
  name: "ChangeEmail",
  data() {
    return {
      step: 1,
      newpwd: null,
      newCpwd: null,
      oldpwd: null,
      userinfo: null,
      sended: false,
      title: "",
      desc: "",
      btn: "Next"
    };
  },
  components: {
    // EmailSuccess,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    firebtn() {
      if (this.step < 3) {
        if (this.step == 1) {
          if (!this.oldpwd) {
            window.alert("Please enter your current password!");
            return;
          }
          CheckOldPwd({ oldpass: this.oldpwd }).then(res => {
            this.step++;
            this.initStep();
          });
        } else if (this.step == 2) {
          if (!this.newpwd && !this.newCpwd) {
            window.alert("Please fill all the required fields!");
            return;
          }
          if (this.newpwd != this.newCpwd) {
            window.alert(
              "Your confirm password doesn't match with your new password."
            );
            return;
          }
          SetNewPwd({ pass: this.newpwd }).then(res => {
            this.step++;
            this.initStep();
          });
        }
      } else {
        this.$emit("close");
        this.step = 1;
      }
    },
    initStep() {
      if (this.step == 1) {
        this.title = `${this.step}. Verify yourself`;
        this.desc = "Enter your current password to continue";
      } else if (this.step == 2) {
        this.title = `${this.step}. Change password`;
        this.desc = "Enter and confirm your new password";
      } else if (this.step == 3) {
        this.title = `${this.step}. Password changed !`;
        this.desc = "Remember to login using your new password next time :)";
        this.btn = "Complete";
      }
    }
  },
  created() {
    this.initStep();
  }
};
</script>

<style scoped>
.change-password {
  width: 740px;
  min-height: 450px;
  position: fixed;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 40px 0;
  border-radius: 20px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.16);
  color: #47666f;
}
.title {
  text-shadow: 0 0 0 #47666f;
  font-size: 28px;
  margin-bottom: 10px;
}

.middle {
  margin: 0 20px;
}
.circle {
  width: 10px;
  height: 10px;
  /* background: #000; */
  border: 1px solid #47666f;
  border-radius: 100%;
  display: inline-block;
  margin-bottom: 10px;
}
.active {
  background: #47666f;
}

.desc {
  font-size: 14px;
  /* width: 250px; */
  display: block;
  margin: 0 auto;
  line-height: 20px;
  letter-spacing: 0.2px;
}

.step1 {
  margin-top: 100px;
}
.step2 {
  margin-top: 60px;
}
.step3 {
  margin-top: 30px;
}

input {
  font-size: 20px;
  padding: 10px 15px;
  display: block;
  border-radius: 50px;
  border-style: none;
  border: 1px solid rgba(71, 102, 111, 0.6);
  width: 340px;
  margin: 0 auto;
  margin-bottom: 15px;
  color: #47666f;
}

.new-email {
  margin-bottom: 40px;
}

.send-code {
  font-size: 18px;
  font-weight: bold;
}
.btn {
  background: #47666f;
  color: white;
  font-weight: bold;
  padding: 10px;
  width: 130px;
  border-radius: 30px;
  font-size: 20px;
}
.buttons {
  position: absolute;
  bottom: 40px;
  right: 40px;
}
.btn,
.close {
  display: inline-block;
  vertical-align: middle;
}

.close {
  margin-right: 15px;
}

.close:hover,
.btn:hover,
.send-code:hover {
  cursor: pointer;
  opacity: 0.8;
}

img {
  width: 350px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue